import { AxiosInstance } from 'axios';
import {
  EmailSubscription,
  MeUpdateStocklistSubscriptionRequest,
  UpdateStocklistSubscriptionRequest,
} from './email-subscriptions.types';

const BASE = '/v1/email-subscriptions';
const ME_BASE = '/v1/me/email-subscriptions';

export const createEmailSubscriptionsApi = (api: AxiosInstance) => ({
  // --- Admin: manage any contact's subscriptions ---

  getByContact: (contactEmployeeId: number) =>
    api
      .get<EmailSubscription[]>(`${BASE}/contact/${contactEmployeeId}`)
      .then((r) => r.data),

  upsertStocklist: (
    contactEmployeeId: number,
    body: UpdateStocklistSubscriptionRequest,
  ) =>
    api
      .put<EmailSubscription>(
        `${BASE}/contact/${contactEmployeeId}/stocklist`,
        body,
      )
      .then((r) => r.data),

  deleteStocklist: (contactEmployeeId: number) =>
    api
      .delete<void>(`${BASE}/contact/${contactEmployeeId}/stocklist`)
      .then((r) => r.data),

  testSendStocklist: (contactEmployeeId: number) =>
    api
      .post<{ message: string }>(
        `${BASE}/contact/${contactEmployeeId}/stocklist/test-send`,
      )
      .then((r) => r.data),

  sendStocklist: (contactEmployeeId: number, email?: string) =>
    api
      .post<{ message: string }>(
        `${BASE}/contact/${contactEmployeeId}/stocklist/send`,
        email ? { email } : {},
      )
      .then((r) => r.data),

  // --- Customer self-service (JWT-scoped) ---

  getMine: () => api.get<EmailSubscription[]>(ME_BASE).then((r) => r.data),

  upsertMyStocklist: (body: MeUpdateStocklistSubscriptionRequest) =>
    api
      .put<EmailSubscription>(`${ME_BASE}/stocklist`, body)
      .then((r) => r.data),

  deleteMyStocklist: (contactEmployeeId?: number) =>
    api
      .delete<void>(`${ME_BASE}/stocklist`, {
        params: contactEmployeeId != null ? { contactEmployeeId } : undefined,
      })
      .then((r) => r.data),

  // --- Public one-click unsubscribe ---

  unsubscribe: (token: string) =>
    api
      .post<{ message: string }>(`${BASE}/unsubscribe/${token}`)
      .then((r) => r.data),
});
